import React, { useRef, useEffect } from 'react';

interface DescriptionProps {
    unitDescription: string;
}

const Description: React.FC<DescriptionProps> = ({ unitDescription }) => {
    const textareaRef = useRef<HTMLTextAreaElement>(null);

    useEffect(() => {
        if (textareaRef.current) {
            textareaRef.current.style.height = 'auto'; // Reset height
            textareaRef.current.style.height = textareaRef.current.scrollHeight + 'px';
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [unitDescription]);

    return (
        <div className="mb-2">
            <textarea
                ref={textareaRef}
                value={unitDescription}
                readOnly
                style={{
                    width: '100%',
                    border: '1px solid #ddd',
                    borderRadius: 6,
                    padding: '16px 18px',
                    fontSize: 18,
                    color: '#444',
                    background: '#fff',
                    resize: 'none', // User can't resize
                    minHeight: 60,
                    boxSizing: 'border-box',
                    overflow: 'hidden', // Hide scroll
                }}
            />
        </div>
    );
};

export default Description;